const LAST_USERNAME_KEY = 'auth.lastUsername'

export const lastUsernameStore = {
  get(): string | null {
    return localStorage.getItem(LAST_USERNAME_KEY)
  },
  set(lastUsername: string): void {
    localStorage.setItem(LAST_USERNAME_KEY, lastUsername)
  },
  clear(): void {
    localStorage.removeItem(LAST_USERNAME_KEY)
  },
}
